// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Cashback from "../../app/entity/Cashback.bs.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as GstinCard from "./GstinCard.bs.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as CustomerForm from "./CustomerForm.bs.js";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Icon$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Column$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as ConfirmationModal from "../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";
import * as CustomerFormStore from "../../app/repo/CustomerFormStore.bs.js";
import * as CustomerApiHandler from "../state-machine/CustomerApiHandler.bs.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as CustomerAssetsManager from "../assets/CustomerAssetsManager.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as MobileNumberValidation from "../../../../../library/work-space/form/MobileNumberValidation.bs.js";
import * as CustomerFormCmpMetaData from "./CustomerFormCmpMetaData.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as FormRadioGroupInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormRadioGroupInput.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as PricingDashboardAssetsManager from "../../../pricing-dashboard/view/assets/PricingDashboardAssetsManager.bs.js";

var error_sign = PricingDashboardAssetsManager.getImage("cross-icon.svg");

function CustomerFormCmp(Props) {
  var customer_data = Props.customer_data;
  var cashback_data = Props.cashback_data;
  var customer_id = Props.customer_id;
  var phone_number = Props.phone_number;
  var geo_region_items = Props.geo_region_items;
  var isAllEditable = Props.isAllEditable;
  var dispatch = Props.dispatch;
  var openSnackbar = Props.openSnackbar;
  var pageRefresh = Props.pageRefresh;
  var closeCustomerInfoSidebar = Props.closeCustomerInfoSidebar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowOtpField = match$1[1];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsSecMobileValid = match$2[1];
  var match$3 = React.useState(function () {
        return false;
      });
  var setIsSecMobileVerified = match$3[1];
  var isSecMobileVerified = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var setIsEmailValid = match$4[1];
  var match$5 = React.useState(function () {
        return false;
      });
  var setShowVerifyEmail = match$5[1];
  var showVerifyEmail = match$5[0];
  var match$6 = React.useState(function () {
        
      });
  var setOtpVerified = match$6[1];
  var otpVerified = match$6[0];
  var match$7 = React.useState(function () {
        
      });
  var setRequestId = match$7[1];
  var requestId = match$7[0];
  var match$8 = React.useState(function () {
        return false;
      });
  var setLoading = match$8[1];
  var match$9 = React.useState(function () {
        return {
                hd: CustomerFormCmpMetaData.default_blacklist_item,
                tl: /* [] */0
              };
      });
  var setBlacklistItems = match$9[1];
  var blacklistItems = match$9[0];
  var checked = CustomerAssetsManager.getImage("check.svg");
  var formData = customer_data.formData;
  var summary = customer_data.summary;
  var match$10 = React.useState(function () {
        return formData.temporarily_deactivated.attribute_value === "true";
      });
  var setisDeactivated = match$10[1];
  var match$11 = React.useState(function () {
        return false;
      });
  var updateConfirmModalState = match$11[1];
  var match$12 = React.useState(function () {
        return [];
      });
  var setGstinsMarkedForDelete = match$12[1];
  var gstinsMarkedForDelete = match$12[0];
  var gstinList = formData.gstin_list;
  var geo_region_select_items = List.append({
        hd: {
          key: "0",
          value: "-1",
          text: "None"
        },
        tl: /* [] */0
      }, List.mapi((function (key, item) {
              return {
                      key: String(key + 1 | 0),
                      value: String(item.id),
                      text: item.name
                    };
            }), geo_region_items));
  var convertBlacklistingReasonsToDropdownItems = function (blacklistingReasons) {
    var reasonItems = Belt_List.mapWithIndex(blacklistingReasons.blacklisting_reasons, (function (index, reason) {
            return {
                    key: String(index + 1 | 0),
                    value: String(reason.id),
                    text: reason.description
                  };
          }));
    return {
            hd: CustomerFormCmpMetaData.default_blacklist_item,
            tl: reasonItems
          };
  };
  var getBlacklistReasonId = function (attributeValue, blacklistingReasons) {
    if (blacklistingReasons === undefined) {
      return attributeValue;
    }
    var foundByEnum = Belt_List.getBy(blacklistingReasons.blacklisting_reasons, (function (reason) {
            var enumValue = reason.reason;
            if (enumValue !== undefined) {
              return enumValue === attributeValue;
            } else {
              return false;
            }
          }));
    if (foundByEnum !== undefined) {
      return String(foundByEnum.id);
    } else {
      return "-1";
    }
  };
  var subscribed_for_promo_sms = formData.subscribed_for_promo_sms;
  var partload_customer = formData.partload_customer;
  var registration_status = formData.registration_status;
  var blacklist_reason = formData.blacklist_reason;
  var temporarily_deactivated = formData.temporarily_deactivated;
  var customer_type = formData.customer_type;
  var unconfirmed_email = formData.unconfirmed_email;
  var email = formData.email;
  var geo_region = formData.geo_region;
  var port_gold_status = formData.port_gold_status;
  var secondary_mobile = formData.secondary_mobile;
  var mobile = formData.mobile;
  var caller_type = formData.caller_type;
  var last_name = formData.last_name;
  var first_name = formData.first_name;
  var getInitialState = function (param) {
    return {
            first_name: first_name.attribute_value,
            last_name: last_name.attribute_value,
            caller_type: caller_type.attribute_value,
            mobile: mobile.attribute_value,
            secondary_mobile: secondary_mobile.attribute_value,
            port_gold_status: port_gold_status.attribute_value,
            geo_region: geo_region.attribute_value,
            unconfirmed_email: unconfirmed_email.attribute_value,
            email: email.attribute_value,
            otp: "",
            customer_type: customer_type.attribute_value,
            temporarily_deactivated: temporarily_deactivated.attribute_value,
            blacklist_reason: blacklist_reason.attribute_value,
            registration_status: registration_status.attribute_value,
            partload_customer: partload_customer.attribute_value,
            subscribed_for_promo_sms: subscribed_for_promo_sms.attribute_value
          };
  };
  var handleError = function (error) {
    Curry._1(setLoading, (function (param) {
            return false;
          }));
    return Curry._1(openSnackbar, {
                TAG: /* Error */1,
                _0: ErrorUtils$Catalyst.resolveError(error)
              });
  };
  var form = CustomerForm.Form.useForm(getInitialState(undefined), {
        country: country
      }, (function (output, param) {
          Curry._1(setLoading, (function (param) {
                  return true;
                }));
          Curry._1(updateConfirmModalState, (function (param) {
                  return false;
                }));
          Curry._1(closeCustomerInfoSidebar, undefined);
          var refetchCustomerSummary = function (param) {
            return CustomerApiHandler.RefetchCustomerSummary.execute((function (customer_data) {
                          return Curry._1(dispatch, {
                                      TAG: /* UpdateCustomer */2,
                                      _0: customer_data
                                    });
                        }), handleError, phone_number, country);
          };
          var submitCustomerUpdate = function (param) {
            return CustomerApiHandler.UpdateCustomer.execute((function (data) {
                          Curry._1(dispatch, {
                                TAG: /* UpdateCustomer */2,
                                _0: data
                              });
                          Curry._1(openSnackbar, {
                                TAG: /* Success */0,
                                _0: "Customer Info Updated!"
                              });
                          refetchCustomerSummary(undefined);
                          Curry._1(setLoading, (function (param) {
                                  return false;
                                }));
                          return Curry._1(pageRefresh, undefined);
                        }), (function (error) {
                          handleError(error);
                          return Curry._1(pageRefresh, undefined);
                        }), {
                        summary: summary,
                        formData: formData
                      }, output, country);
          };
          if (gstinsMarkedForDelete.length !== 0) {
            return CustomerApiHandler.DeleteGstins.execute((function (param) {
                          Curry._1(setGstinsMarkedForDelete, (function (param) {
                                  return [];
                                }));
                          return submitCustomerUpdate(undefined);
                        }), (function (error) {
                          handleError(error);
                          return Curry._1(pageRefresh, undefined);
                        }), summary.uuid, phone_number, gstinsMarkedForDelete, country);
          } else {
            return submitCustomerUpdate(undefined);
          }
        }));
  React.useEffect((function () {
          CustomerApiHandler.FetchBlacklistingReasons.execute(country, (function (data) {
                  var dropdownItems = convertBlacklistingReasonsToDropdownItems(data);
                  Curry._1(setBlacklistItems, (function (param) {
                          return dropdownItems;
                        }));
                  var correctedId = getBlacklistReasonId(blacklist_reason.attribute_value, data);
                  if (correctedId !== form.input.blacklist_reason) {
                    Curry._2(form.updateBlacklist_reason, (function (input, value) {
                            return {
                                    first_name: input.first_name,
                                    last_name: input.last_name,
                                    caller_type: input.caller_type,
                                    mobile: input.mobile,
                                    secondary_mobile: input.secondary_mobile,
                                    port_gold_status: input.port_gold_status,
                                    geo_region: input.geo_region,
                                    unconfirmed_email: input.unconfirmed_email,
                                    email: input.email,
                                    otp: input.otp,
                                    customer_type: input.customer_type,
                                    temporarily_deactivated: input.temporarily_deactivated,
                                    blacklist_reason: value,
                                    registration_status: input.registration_status,
                                    partload_customer: input.partload_customer,
                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                  };
                          }), correctedId);
                    if (form.input.temporarily_deactivated === "true") {
                      return Curry._1(form.blurBlacklist_reason, undefined);
                    } else {
                      return ;
                    }
                  }
                  
                }), (function (error) {
                  console.error("Failed to fetch blacklisting reasons: " + ErrorUtils$Catalyst.resolveError(error));
                  
                }));
          
        }), [blacklist_reason.attribute_value]);
  React.useEffect((function () {
          var isNumberSame = form.input.secondary_mobile === secondary_mobile.attribute_value;
          Curry._1(setIsSecMobileVerified, (function (param) {
                  var match = secondary_mobile.is_verified;
                  if (match && isNumberSame) {
                    return true;
                  } else {
                    return false;
                  }
                }));
          var _error = MobileNumberValidation.execute(form.input.secondary_mobile, country);
          if (_error.TAG === /* Ok */0) {
            Curry._1(setIsSecMobileValid, (function (param) {
                    return true;
                  }));
          } else {
            Curry._1(setIsSecMobileValid, (function (param) {
                    return false;
                  }));
          }
          
        }), [form.input.secondary_mobile]);
  React.useEffect((function () {
          var isEmailSame = form.input.unconfirmed_email === unconfirmed_email.attribute_value;
          var isEmailComing = unconfirmed_email.attribute_value.length !== 0;
          Curry._1(setShowVerifyEmail, (function (param) {
                  if (isEmailSame && isEmailComing) {
                    return true;
                  } else {
                    return false;
                  }
                }));
          var _error = FormValidationUtils$Catalyst.validateEmail(form.input.unconfirmed_email);
          if (_error.TAG === /* Ok */0) {
            Curry._1(setIsEmailValid, (function (param) {
                    return true;
                  }));
          } else {
            Curry._1(setIsEmailValid, (function (param) {
                    return false;
                  }));
          }
          
        }), [form.input.unconfirmed_email]);
  React.useEffect((function () {
          var otp = form.input.otp;
          var match = otp.length;
          if (match !== 6) {
            
          } else {
            CustomerApiHandler.VerifyOtpRequest.execute((function (_data) {
                    Curry._1(openSnackbar, {
                          TAG: /* Success */0,
                          _0: "Successfully updated!"
                        });
                    return Curry._1(setOtpVerified, (function (param) {
                                  return {
                                          TAG: /* Success */0,
                                          _0: "Number successfully updated!"
                                        };
                                }));
                  }), (function (param) {
                    Curry._1(openSnackbar, {
                          TAG: /* Error */1,
                          _0: "Something Went Wrong"
                        });
                    return Curry._1(setOtpVerified, (function (param) {
                                  return {
                                          TAG: /* Error */1,
                                          _0: "Incorrect OTP! Please enter the correct OTP"
                                        };
                                }));
                  }), customer_id, Belt_Option.getWithDefault(requestId, 0), Caml_format.caml_int_of_string(otp), phone_number, country);
          }
          
        }), [form.input.otp]);
  React.useEffect((function () {
          if (gstinsMarkedForDelete.length !== 0) {
            Curry._1(setGstinsMarkedForDelete, (function (param) {
                    return [];
                  }));
          }
          
        }), [isAllEditable]);
  var tmp;
  if (match$8[0]) {
    tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
  } else {
    var tmp$1;
    if (match$1[0]) {
      var resendSection = React.createElement("div", {
            className: "resend-otp"
          }, React.createElement("p", undefined, CustomerFormStore.optNotReceivedText), React.createElement(Button$Catalyst.make, {
                text: "Resend OTP",
                cb: (function (_event) {
                    return CustomerApiHandler.ResendOTP.execute((function (data) {
                                  Curry._1(setRequestId, (function (param) {
                                          return data.request_id;
                                        }));
                                  return Curry._1(openSnackbar, {
                                              TAG: /* Success */0,
                                              _0: data.message
                                            });
                                }), (function (param) {
                                  return Curry._1(openSnackbar, {
                                              TAG: /* Error */1,
                                              _0: "something went wrong sending otp"
                                            });
                                }), customer_id, Belt_Option.getWithDefault(requestId, 0), phone_number, country);
                  }),
                className: "btn-secondary"
              }));
      var tmp$2;
      tmp$2 = otpVerified !== undefined ? (
          otpVerified.TAG === /* Success */0 ? React.createElement(React.Fragment, undefined, React.createElement("img", {
                      className: "checked",
                      src: checked
                    }), React.createElement("p", {
                      className: "otp-success"
                    }, otpVerified._0)) : React.createElement(React.Fragment, undefined, React.createElement(Icon$Catalyst.InfoIcon.make, {
                      className: "error-icon"
                    }), React.createElement("p", {
                      className: "otp-error"
                    }, otpVerified._0), resendSection)
        ) : resendSection;
      tmp$1 = React.createElement(React.Fragment, undefined, React.createElement(Column$Catalyst.make, {
                children: null,
                className: "otp"
              }, React.createElement("div", {
                    className: "label"
                  }, CustomerFormStore.otpText + form.input.secondary_mobile), React.createElement(FormTextInput$Catalyst.make, {
                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                            return Curry._2(form.updateOtp, (function (input, value) {
                                          if (/^[0-9]*$/.test(value)) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: input.last_name,
                                                    caller_type: input.caller_type,
                                                    mobile: input.mobile,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: value.substring(0, 6),
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          } else {
                                            return input;
                                          }
                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                          }), undefined, undefined, undefined, undefined, undefined, undefined, form.otpResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                    textinput_props: {
                      value: form.input.otp
                    }
                  }), tmp$2));
    } else {
      tmp$1 = null;
    }
    var tmp$3;
    tmp$3 = country.TAG === /* India */1 && gstinList.length !== 0 ? React.createElement("div", {
            className: "gstin-section"
          }, React.createElement("span", {
                className: "gstin-section__title"
              }, "GSTINs"), React.createElement("div", {
                className: "gstin-section__list"
              }, Belt_Array.map(gstinList, (function (gst) {
                      return React.createElement(GstinCard.make, {
                                  gstinValue: gst.gstin,
                                  companyName: gst.gst_business_name,
                                  companyAddress: gst.gst_address,
                                  addedOn: gst.updated_at,
                                  onDelete: (function (param) {
                                      var gstin = gst.gstin;
                                      return Curry._1(setGstinsMarkedForDelete, (function (marked) {
                                                    return Belt_Array.concat(marked, [gstin]);
                                                  }));
                                    }),
                                  onUndo: (function (param) {
                                      var gstin = gst.gstin;
                                      return Curry._1(setGstinsMarkedForDelete, (function (marked) {
                                                    return Belt_Array.keep(marked, (function (marked) {
                                                                  return marked !== gstin;
                                                                }));
                                                  }));
                                    }),
                                  isStruckOut: Belt_Array.some(gstinsMarkedForDelete, (function (marked) {
                                          return marked === gst.gstin;
                                        })),
                                  canDelete: isAllEditable,
                                  key: gst.gstin
                                });
                    })))) : null;
    var emailToDisplay = email.attribute_value;
    var isVerified = unconfirmed_email.attribute_value.length !== 0 ? true : email.is_verified;
    var emailLabel = isVerified ? CustomerFormStore.emailStatusVerified + " " + CustomerFormStore.emailTitle : CustomerFormStore.emailStatusUnconfirmed + " " + CustomerFormStore.emailTitle;
    tmp = React.createElement("div", {
          className: "form-container"
        }, React.createElement(Row$Catalyst.make, {
              children: null
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "w-50"
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.firstNameLabel), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateFirst_name, (function (input, value) {
                                            return {
                                                    first_name: value,
                                                    last_name: input.last_name,
                                                    caller_type: input.caller_type,
                                                    mobile: input.mobile,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !first_name.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.first_nameResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.first_name
                      }
                    })), React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "w-50"
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.lastNameLabel), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateLast_name, (function (input, value) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: value,
                                                    caller_type: input.caller_type,
                                                    mobile: input.mobile,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !last_name.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.last_nameResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.last_name
                      }
                    }))), React.createElement(Row$Catalyst.make, {
              children: null
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "w-50"
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.callerTypeLabel), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateCaller_type, (function (input, value) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: input.last_name,
                                                    caller_type: value,
                                                    mobile: input.mobile,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !caller_type.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.caller_typeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.caller_type
                      }
                    })), React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "w-50"
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.primMobileLabel), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateMobile, (function (input, value) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: input.last_name,
                                                    caller_type: input.caller_type,
                                                    mobile: value,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !mobile.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.mobileResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.mobile
                      }
                    }))), React.createElement(Row$Catalyst.make, {
              children: null,
              className: "secondary-number"
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: isAllEditable && !isSecMobileVerified ? "w-50" : ""
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.secMobileLabel), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateSecondary_mobile, (function (input, value) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: input.last_name,
                                                    caller_type: input.caller_type,
                                                    mobile: input.mobile,
                                                    secondary_mobile: value,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !secondary_mobile.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.secondary_mobileResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.secondary_mobile
                      }
                    })), isSecMobileVerified ? React.createElement("img", {
                    className: "checked",
                    src: checked
                  }) : (
                isAllEditable ? React.createElement(Column$Catalyst.make, {
                        children: null,
                        className: "w-50"
                      }, React.createElement("div", {
                            className: "label"
                          }, ""), React.createElement(Button$Catalyst.make, {
                            text: CustomerFormStore.addSecNumberBtnText,
                            cb: (function (_event) {
                                var secondary_mobile = form.input.secondary_mobile;
                                if (secondary_mobile.length === 0) {
                                  return ;
                                }
                                var error = MobileNumberValidation.execute(secondary_mobile, country);
                                if (error.TAG === /* Ok */0) {
                                  return CustomerApiHandler.AddSecondaryNumber.execute((function (data) {
                                                Curry._1(setRequestId, (function (param) {
                                                        return data.request_id;
                                                      }));
                                                Curry._1(openSnackbar, {
                                                      TAG: /* Success */0,
                                                      _0: data.message
                                                    });
                                                return Curry._1(setShowOtpField, (function (param) {
                                                              return true;
                                                            }));
                                              }), (function (param) {
                                                return Curry._1(openSnackbar, {
                                                            TAG: /* Error */1,
                                                            _0: "Number is already exist or not valid"
                                                          });
                                              }), customer_id, secondary_mobile, phone_number, country);
                                } else {
                                  return Curry._1(openSnackbar, {
                                              TAG: /* Error */1,
                                              _0: error._0
                                            });
                                }
                              }),
                            className: "btn-secondary disabled",
                            disabled: !match$2[0]
                          })) : null
              )), tmp$1, tmp$3, React.createElement(Row$Catalyst.make, {
              children: null
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "w-50"
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.porterGoldStatusLabel), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updatePort_gold_status, (function (input, value) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: input.last_name,
                                                    caller_type: input.caller_type,
                                                    mobile: input.mobile,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: value,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !port_gold_status.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.port_gold_statusResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.port_gold_status
                      }
                    })), React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "w-50"
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.geoRegionLabel), React.createElement(FormSelectInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateGeo_region, (function (input, value) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: input.last_name,
                                                    caller_type: input.caller_type,
                                                    mobile: input.mobile,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: value,
                                                    unconfirmed_email: input.unconfirmed_email,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !geo_region.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.geo_regionResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      select_props: {
                        value: CustomerFormCmpMetaData.getSelectedItem(geo_region_select_items, form.input.geo_region),
                        items: geo_region_select_items,
                        isNoneRequired: false
                      }
                    }))), emailToDisplay.length !== 0 ? React.createElement(Column$Catalyst.make, {
                children: React.createElement("div", {
                      className: "email-card"
                    }, React.createElement("p", {
                          className: "title"
                        }, emailLabel), React.createElement("p", {
                          className: isVerified ? "content" : "content grey red-text"
                        }, emailToDisplay), isVerified ? React.createElement("img", {
                            className: "checked",
                            src: checked
                          }) : React.createElement("img", {
                            className: "error-img",
                            alt: "Error",
                            src: error_sign
                          })),
                className: "confirmed-mail"
              }) : null, React.createElement(Row$Catalyst.make, {
              children: null,
              className: "email"
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: isAllEditable && showVerifyEmail ? "w-50" : ""
                }, React.createElement("div", {
                      className: "label"
                    }, CustomerFormStore.emailLabel), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateUnconfirmed_email, (function (input, value) {
                                            return {
                                                    first_name: input.first_name,
                                                    last_name: input.last_name,
                                                    caller_type: input.caller_type,
                                                    mobile: input.mobile,
                                                    secondary_mobile: input.secondary_mobile,
                                                    port_gold_status: input.port_gold_status,
                                                    geo_region: input.geo_region,
                                                    unconfirmed_email: value,
                                                    email: input.email,
                                                    otp: input.otp,
                                                    customer_type: input.customer_type,
                                                    temporarily_deactivated: input.temporarily_deactivated,
                                                    blacklist_reason: input.blacklist_reason,
                                                    registration_status: input.registration_status,
                                                    partload_customer: input.partload_customer,
                                                    subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), isAllEditable ? !unconfirmed_email.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.unconfirmed_emailResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.unconfirmed_email
                      }
                    })), isAllEditable ? (
                showVerifyEmail ? React.createElement(Column$Catalyst.make, {
                        children: null,
                        className: "w-50"
                      }, React.createElement("div", {
                            className: "label"
                          }, ""), React.createElement(Button$Catalyst.make, {
                            text: CustomerFormStore.verifyEmailBtnTxt,
                            cb: (function (_event) {
                                return CustomerApiHandler.VerifyEmail.execute((function (data) {
                                              return Curry._1(openSnackbar, {
                                                          TAG: /* Success */0,
                                                          _0: "A confirmation link has been sent to " + data.recipient
                                                        });
                                            }), (function (param) {
                                              return Curry._1(openSnackbar, {
                                                          TAG: /* Error */1,
                                                          _0: "Something Went Wrong"
                                                        });
                                            }), customer_id, country);
                              }),
                            className: "btn-secondary disabled",
                            disabled: !match$4[0]
                          })) : null
              ) : (
                showVerifyEmail ? React.createElement(React.Fragment, undefined, React.createElement(Icon$Catalyst.InfoIcon.make, {
                            className: "error-icon"
                          }), React.createElement("p", {
                            className: "email-verify"
                          }, CustomerFormStore.unverifiedEmailLabel)) : null
              )), React.createElement(Column$Catalyst.make, {
              children: null
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.cashbackSlabLabel), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", undefined, true, undefined, undefined, undefined, undefined, undefined, {
                        TAG: /* Ok */0,
                        _0: cashback_data.slab
                      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: Cashback.getStringFromSlab(cashback_data.slab)
                  }
                })), React.createElement(Column$Catalyst.make, {
              children: null
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.cashbackOfferedLabel), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", undefined, true, undefined, undefined, undefined, undefined, undefined, {
                        TAG: /* Ok */0,
                        _0: cashback_data.offered
                      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: Currency.toString(cashback_data.offered)
                  }
                })), React.createElement(Column$Catalyst.make, {
              children: null
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.cashbackRedeemedLabel), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", undefined, true, undefined, undefined, undefined, undefined, undefined, {
                        TAG: /* Ok */0,
                        _0: cashback_data.redeemed
                      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: Currency.toString(cashback_data.redeemed)
                  }
                })), React.createElement(Column$Catalyst.make, {
              children: null
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.cashbackBalanceLabel), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", undefined, true, undefined, undefined, undefined, undefined, undefined, {
                        TAG: /* Ok */0,
                        _0: cashback_data.balance
                      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: Currency.toString(cashback_data.balance)
                  }
                })), React.createElement(Column$Catalyst.make, {
              children: null,
              className: ""
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.customerTypeLabel), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          return Curry._2(form.updateCustomer_type, (function (input, value) {
                                        return {
                                                first_name: input.first_name,
                                                last_name: input.last_name,
                                                caller_type: input.caller_type,
                                                mobile: input.mobile,
                                                secondary_mobile: input.secondary_mobile,
                                                port_gold_status: input.port_gold_status,
                                                geo_region: input.geo_region,
                                                unconfirmed_email: input.unconfirmed_email,
                                                email: input.email,
                                                otp: input.otp,
                                                customer_type: value,
                                                temporarily_deactivated: input.temporarily_deactivated,
                                                blacklist_reason: input.blacklist_reason,
                                                registration_status: input.registration_status,
                                                partload_customer: input.partload_customer,
                                                subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), isAllEditable ? !customer_type.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.customer_typeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: CustomerFormCmpMetaData.getSelectedItem(CustomerFormCmpMetaData.cust_type_items, form.input.customer_type),
                    items: CustomerFormCmpMetaData.cust_type_items,
                    isNoneRequired: false
                  }
                })), React.createElement(Column$Catalyst.make, {
              children: null
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.temporarilyDeactivatedLabel), React.createElement(FormRadioGroupInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          var value = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                          Curry._1(setisDeactivated, (function (param) {
                                  return value === "true";
                                }));
                          Curry._2(form.updateTemporarily_deactivated, (function (input, value) {
                                  return {
                                          first_name: input.first_name,
                                          last_name: input.last_name,
                                          caller_type: input.caller_type,
                                          mobile: input.mobile,
                                          secondary_mobile: input.secondary_mobile,
                                          port_gold_status: input.port_gold_status,
                                          geo_region: input.geo_region,
                                          unconfirmed_email: input.unconfirmed_email,
                                          email: input.email,
                                          otp: input.otp,
                                          customer_type: input.customer_type,
                                          temporarily_deactivated: value,
                                          blacklist_reason: input.blacklist_reason,
                                          registration_status: input.registration_status,
                                          partload_customer: input.partload_customer,
                                          subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                        };
                                }), value);
                          if (value === "false") {
                            Curry._2(form.updateBlacklist_reason, (function (input, value) {
                                    return {
                                            first_name: input.first_name,
                                            last_name: input.last_name,
                                            caller_type: input.caller_type,
                                            mobile: input.mobile,
                                            secondary_mobile: input.secondary_mobile,
                                            port_gold_status: input.port_gold_status,
                                            geo_region: input.geo_region,
                                            unconfirmed_email: input.unconfirmed_email,
                                            email: input.email,
                                            otp: input.otp,
                                            customer_type: input.customer_type,
                                            temporarily_deactivated: input.temporarily_deactivated,
                                            blacklist_reason: value,
                                            registration_status: input.registration_status,
                                            partload_customer: input.partload_customer,
                                            subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                          };
                                  }), "-1");
                          }
                          return Curry._1(form.blurBlacklist_reason, undefined);
                        }), isAllEditable ? !temporarily_deactivated.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.temporarily_deactivatedResult, undefined, "temporarily-deactivated", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  radio_props: {
                    options: CustomerFormCmpMetaData.radio_items,
                    value: form.input.temporarily_deactivated,
                    row_layout: true
                  }
                })), match$10[0] ? React.createElement(Column$Catalyst.make, {
                children: React.createElement(FormSelectInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              Curry._2(form.updateBlacklist_reason, (function (input, value) {
                                      return {
                                              first_name: input.first_name,
                                              last_name: input.last_name,
                                              caller_type: input.caller_type,
                                              mobile: input.mobile,
                                              secondary_mobile: input.secondary_mobile,
                                              port_gold_status: input.port_gold_status,
                                              geo_region: input.geo_region,
                                              unconfirmed_email: input.unconfirmed_email,
                                              email: input.email,
                                              otp: input.otp,
                                              customer_type: input.customer_type,
                                              temporarily_deactivated: input.temporarily_deactivated,
                                              blacklist_reason: value,
                                              registration_status: input.registration_status,
                                              partload_customer: input.partload_customer,
                                              subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                            };
                                    }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              return Curry._1(form.blurBlacklist_reason, undefined);
                            }), isAllEditable ? !blacklist_reason.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.blacklist_reasonResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      select_props: {
                        value: CustomerFormCmpMetaData.getSelectedItem(blacklistItems, form.input.blacklist_reason),
                        items: blacklistItems,
                        isNoneRequired: false
                      }
                    })
              }) : null, React.createElement(Column$Catalyst.make, {
              children: null,
              className: ""
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.registrationStatusLabel), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          return Curry._2(form.updateRegistration_status, (function (input, value) {
                                        return {
                                                first_name: input.first_name,
                                                last_name: input.last_name,
                                                caller_type: input.caller_type,
                                                mobile: input.mobile,
                                                secondary_mobile: input.secondary_mobile,
                                                port_gold_status: input.port_gold_status,
                                                geo_region: input.geo_region,
                                                unconfirmed_email: input.unconfirmed_email,
                                                email: input.email,
                                                otp: input.otp,
                                                customer_type: input.customer_type,
                                                temporarily_deactivated: input.temporarily_deactivated,
                                                blacklist_reason: input.blacklist_reason,
                                                registration_status: value,
                                                partload_customer: input.partload_customer,
                                                subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), isAllEditable ? !registration_status.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.registration_statusResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: CustomerFormCmpMetaData.getSelectedItem(CustomerFormCmpMetaData.reg_status_items, form.input.registration_status),
                    items: CustomerFormCmpMetaData.reg_status_items,
                    isNoneRequired: false
                  }
                })), React.createElement(Column$Catalyst.make, {
              children: null
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.partloadCustomerLabel), React.createElement(FormRadioGroupInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          return Curry._2(form.updatePartload_customer, (function (input, value) {
                                        return {
                                                first_name: input.first_name,
                                                last_name: input.last_name,
                                                caller_type: input.caller_type,
                                                mobile: input.mobile,
                                                secondary_mobile: input.secondary_mobile,
                                                port_gold_status: input.port_gold_status,
                                                geo_region: input.geo_region,
                                                unconfirmed_email: input.unconfirmed_email,
                                                email: input.email,
                                                otp: input.otp,
                                                customer_type: input.customer_type,
                                                temporarily_deactivated: input.temporarily_deactivated,
                                                blacklist_reason: input.blacklist_reason,
                                                registration_status: input.registration_status,
                                                partload_customer: value,
                                                subscribed_for_promo_sms: input.subscribed_for_promo_sms
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), isAllEditable ? !partload_customer.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.partload_customerResult, undefined, "partload-customer", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  radio_props: {
                    options: CustomerFormCmpMetaData.radio_items,
                    value: form.input.partload_customer,
                    row_layout: true
                  }
                })), React.createElement(Column$Catalyst.make, {
              children: null
            }, React.createElement("div", {
                  className: "label"
                }, CustomerFormStore.subForPromoSMSLabel), React.createElement(FormRadioGroupInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          return Curry._2(form.updateSubscribed_for_promo_sms, (function (input, value) {
                                        return {
                                                first_name: input.first_name,
                                                last_name: input.last_name,
                                                caller_type: input.caller_type,
                                                mobile: input.mobile,
                                                secondary_mobile: input.secondary_mobile,
                                                port_gold_status: input.port_gold_status,
                                                geo_region: input.geo_region,
                                                unconfirmed_email: input.unconfirmed_email,
                                                email: input.email,
                                                otp: input.otp,
                                                customer_type: input.customer_type,
                                                temporarily_deactivated: input.temporarily_deactivated,
                                                blacklist_reason: input.blacklist_reason,
                                                registration_status: input.registration_status,
                                                partload_customer: input.partload_customer,
                                                subscribed_for_promo_sms: value
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), isAllEditable ? !subscribed_for_promo_sms.is_editable : true, undefined, undefined, undefined, undefined, undefined, form.subscribed_for_promo_smsResult, undefined, "subscribed-for-promo", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  radio_props: {
                    options: CustomerFormCmpMetaData.radio_items,
                    value: form.input.subscribed_for_promo_sms,
                    row_layout: true
                  }
                })));
  }
  return React.createElement("div", {
              className: "basic-details-form-conatainer"
            }, tmp, React.createElement("div", {
                  className: "footer"
                }, React.createElement(Button$Catalyst.make, {
                      text: "Save Changes",
                      cb: (function (_event) {
                          return Curry._1(updateConfirmModalState, (function (param) {
                                        return true;
                                      }));
                        }),
                      className: "submit-btn",
                      disabled: !isAllEditable || !Curry._1(form.valid, undefined)
                    }), React.createElement(ConfirmationModal.make, {
                      title: CustomerFormStore.confirmSubmitText,
                      isOpen: match$11[0],
                      onConfirmCb: (function (param) {
                          return Curry._1(form.submit, undefined);
                        }),
                      onCancelCb: (function (param) {
                          return Curry._1(updateConfirmModalState, (function (param) {
                                        return false;
                                      }));
                        }),
                      confirm_button_title: "Submit",
                      cancel_button_title: "Cancel",
                      children: React.createElement("div", undefined, "You are about to make changes to the Customer Information. Are you sure you wish to continue?")
                    })));
}

var make = CustomerFormCmp;

export {
  error_sign ,
  make ,
  
}
/* error_sign Not a pure module */
